// @ts-nocheck
import OrdersPage from './orders';
import ParametersPage from './parameters';
import AvailabilityPage from './availability';
import AdvertisingPage from './advertising';
import MasterDataPage from './masterData';
import Replenishment from './replenishment';
import Reporting from './reporting';
import LowesForecast from './lowesForecast';
import Aim from './aim';
import Matrix from './matrix';
import HomePage from './home';
import IntelligencePage from './intelligence';
import KitsPage from './orders/kits';
import ResetModel from './models/resetModel';
import PaginationModel from './models/paginationModel';
import DemandPlanningPage from './demandPlanning';
import AdminSettings from './adminSettings';
import { Planogram } from './planogram';
import Raupload from './raupload';
import OrderBySku from './orderBySku';

export const Pages = [
	OrdersPage,
	AdvertisingPage,
	ParametersPage,
	AvailabilityPage,
	MasterDataPage,
	IntelligencePage,
	KitsPage,
	HomePage,
	DemandPlanningPage,
	ResetModel,
	Planogram,
	AdminSettings,
	PaginationModel,
	Raupload,
	Replenishment,
	Reporting,
	Aim,
	LowesForecast,
	Matrix,
	OrderBySku,
];

export const BreadCrumbsPages = [MasterDataPage, OrdersPage, Planogram, AdminSettings];
